import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { Button, Form, FormGroup, Label, Input, Spinner } from 'reactstrap';
import ReCAPTCHA from "react-google-recaptcha";
import ReactGA from 'react-ga';

@inject("mobxStore")
@observer
export class RequestMoreInfo extends Component {

  constructor (props) {
    super(props);

    this.state = {
        name: '',
        email: '',
        phone: '',
        posted: false,
        reCapcha: false,
        message: ''
    }
  }
  componentDidMount() {
    const listingId = this.props.forGeneralEmail ? '' : this.props.listingId;
    ReactGA.set({ page: `RequestMoreInfo: ${listingId}` });
    ReactGA.pageview(`/property/requestMoreInfo/${listingId}`);
  }

  handleChange = (target) => {
    this.setState({
        [target.name]: target.value
    })
  }
  handleSubmit = () => {
      const rmi = {
          listingId: this.props.listingId,
          name: this.state.name,
          email: this.state.email,
          phone: this.state.phone,
          message: this.state.message,
          forGeneralEmail: this.props.forGeneralEmail

      }
      this.props.mobxStore.sendRequestMoreInfo(rmi);
      this.setState({posted: true});
  }

  onCaptchaChange = (value) => {
    if (value){
        this.setState({reCapcha: true});
    }
  }

  render () {
    const {forGeneralEmail} = this.props;
    const {posting} = this.props.mobxStore;

    return (
        <Fragment>
            {!forGeneralEmail &&
                <p>Send us your contact information and we will contact you regarding this listing {this.props.listingId}.</p>
            }
            { forGeneralEmail &&
                <p>Send us your contact information and message. We will contact you as soon as we can.</p>
            }
            <Form>
                <FormGroup>
                    <Label for="name">Name</Label>
                    <Input name="name" id="name" placeholder="Your name" value={this.state.name} onChange={(e) => this.handleChange(e.target)}/>
                </FormGroup>
                <FormGroup>
                    <Label for="email">Email</Label>
                    <Input type="email" name="email" id="email" placeholder="Your email" value={this.state.email} onChange={(e) => this.handleChange(e.target)}/>
                </FormGroup>
                <FormGroup>
                    <Label for="phone">Phone</Label>
                    <Input name="phone" id="phone" placeholder="Your phone number" value={this.state.phone} onChange={(e) => this.handleChange(e.target)}/>
                </FormGroup>
                { forGeneralEmail &&
                    <FormGroup>
                        <Label for="message">Message</Label>
                        <Input type="textarea" name="message" id="message" value={this.state.message} onChange={(e) => this.handleChange(e.target)}/>
                    </FormGroup>
                }
                <ReCAPTCHA sitekey="6LcNC70UAAAAAPTx7c4Bb16JZc2tSdcbXrdOer1Y" onChange={(value) => this.onCaptchaChange(value)} />
                <Button className="mt-2" type="button" onClick={(e) => this.handleSubmit()} disabled={!this.state.reCapcha}>
                    { !forGeneralEmail &&
                        <span>Request More Information</span>
                    }
                    { forGeneralEmail &&
                        <span>Send us a Message</span>
                    }
                </Button>
            </Form>

            { posting &&
                <Spinner size="lg"/>
            }
            { !posting && this.state.posted &&
                <p className="mt-3 font-weight-bold">Thank you for the request we will get back to you soon!</p>
            }
        </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RequestMoreInfo.jsx